<template>
	<transition
			name="custom-classes-transition"
			:enter-active-class="$_stgNavDrw_styleComponentAnimation()">
		<template v-if="$_stgNavDrw_stateComponentIsInitialized">
			<v-navigation-drawer
					v-model="$store.state.component.showSettingNavigationDrawer"

					disable-resize-watcher
					fixed

					:color="$_stgNavDrw_styleNavigationDrawerColor"
					:dark="$_stgNavDrw_styleNavigationDrawerDark"
					:light="$_stgNavDrw_styleNavigationDrawerLight"
					:width="$_stgNavDrw_styleNavigationDrawerWidth">
				<v-list
						:color="$_stgNavDrw_styleListColor"
						:dark="$_stgNavDrw_styleListDark"
						:dense="$_stgNavDrw_styleListDense"
						:elevation="$_stgNavDrw_styleListElevation"
						:flat="$_stgNavDrw_styleListFlat"
						:light="$_stgNavDrw_styleListLight"
						:nav="$_stgNavDrw_styleListNav"
						:rounded="$_stgNavDrw_styleListRounded"
						:shaped="$_stgNavDrw_styleListShaped"
						:subheader="$_stgNavDrw_styleListSubheader"
						:three-line="$_stgNavDrw_styleListThreeLine"
						:tile="$_stgNavDrw_styleListTile"
						:two-line="$_stgNavDrw_styleListTwoLine">
					<v-list-item 
							class="customVListItem closeButton_" 
							@click="$_stgNavDrw_toggeleNavigationDrawer">
						<v-list-item-icon>
							<v-icon>close</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								<span	class="overline"
										v-html="$_stgNavDrw_langCloseButton" />
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<setting-list />
				<template v-slot:append>
					<version-info-footer />
				</template>
			</v-navigation-drawer>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'SettingNavigationDrawer',
		data() {
			return {
				componentName_: 'settingNavigationDrawer'
			}
		},
		computed: {
			// state
			$_stgNavDrw_stateComponentShowSettingNavigationDrawer() {
				const self_ = this;
				return self_.getComponentState('showSettingNavigationDrawer')
			},
			$_stgNavDrw_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// contents / inits
			$_stgNavDrw_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_stgNavDrw_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// lang
			$_stgNavDrw_langCloseButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_stgNavDrw_inits(), 'closeButton')
				return self_.getLangsVal(lang_)
			},
			// style
			$_stgNavDrw_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'component')
				}
			},
			$_stgNavDrw_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_stgNavDrw_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_stgNavDrw_styleNavigationDrawer() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_stgNavDrw_inits(), 'navigationDrawer')
			},
			$_stgNavDrw_styleNavigationDrawerColor() {
				const self_ = this;
				const style_ = self_.$_stgNavDrw_styleNavigationDrawer;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_stgNavDrw_styleNavigationDrawerDark() {
				const self_ = this;
				const style_ = self_.$_stgNavDrw_styleNavigationDrawer;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_stgNavDrw_styleNavigationDrawerLight() {
				const self_ = this;
				const style_ = self_.$_stgNavDrw_styleNavigationDrawer;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_stgNavDrw_styleNavigationDrawerWidth() {
				const self_ = this;
				const style_ = self_.$_stgNavDrw_styleNavigationDrawer;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.width)
			},
			$_stgNavDrw_styleList() {
				const self_ = this;
				if(self_.isEmpty(self_.$_stgNavDrw_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_stgNavDrw_inits(), 'list')
			},
			$_stgNavDrw_styleListColor() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.color)
			},
			$_stgNavDrw_styleListDark() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.dark)
			},
			$_stgNavDrw_styleListDense() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.dense)
			},
			$_stgNavDrw_styleListElevation() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.elevation)
			},
			$_stgNavDrw_styleListFlat() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.flat)
			},
			$_stgNavDrw_styleListLight() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.light)
			},
			$_stgNavDrw_styleListNav() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.nav)
			},
			$_stgNavDrw_styleListRounded() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.rounded)
			},
			$_stgNavDrw_styleListShaped() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.shaped)
			},
			$_stgNavDrw_styleListSubheader() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.subheader)
			},
			$_stgNavDrw_styleListThreeLine() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.threeLine)
			},
			$_stgNavDrw_styleListTile() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.tile)
			},
			$_stgNavDrw_styleListTwoLine() {
				const self_ = this;
				const list_ = self_.$_stgNavDrw_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.twoLine)
			}
		},
		methods: {
			$_stgNavDrw_toggeleNavigationDrawer() {
				const self_ = this;

				if(self_.$_stgNavDrw_stateComponentShowSettingNavigationDrawer) {
					self_.setComponentState('showSettingNavigationDrawer', false)
				} else {
					self_.setComponentState('showSettingNavigationDrawer', true)
				}
			}
		}
	}
</script>

<style scoped>
	@media screen and (max-width:1264px) {
		.closeButton_ {
			display: none;
		}
	}
</style>